export const DASHBOARD_STATES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
};

export const PERMISSION_TYPES = {
  VIEW: 'view',
  EDIT: 'edit',
  CREATE: 'create',
};

/** Sub-permisos de edición (alineados a Figma CT-2500) */
export const EDIT_PERMISSIONS = {
  MOVE: 'move',
  RESIZE: 'resize',
  RENAME: 'rename',
  CONFIGURE: 'configure',
  ADD_WIDGET: 'add_widget',
};

/** Orden fijo de filas en el dropdown y en resúmenes */
export const EDIT_PERMISSION_ORDER = [
  EDIT_PERMISSIONS.MOVE,
  EDIT_PERMISSIONS.RESIZE,
  EDIT_PERMISSIONS.RENAME,
  EDIT_PERMISSIONS.CONFIGURE,
];

export const VIEW_PERMISSIONS = {
  VIEW_ONLY: 'view_only',
  EXPORT_DATA: 'export_data',
};

export const VIEW_PERMISSION_ORDER = [VIEW_PERMISSIONS.VIEW_ONLY, VIEW_PERMISSIONS.EXPORT_DATA];

/** Labels para checkboxes del dropdown (Figma CT-2500) */
export const EDIT_PERMISSION_LABELS = {
  [EDIT_PERMISSIONS.MOVE]: 'Move widgets',
  [EDIT_PERMISSIONS.RESIZE]: 'Resize widgets',
  [EDIT_PERMISSIONS.RENAME]: 'Change name of widgets',
  [EDIT_PERMISSIONS.CONFIGURE]: 'Configure widgets',
  [EDIT_PERMISSIONS.ADD_WIDGET]: 'Add new widgets',
};

export const MAX_VISIBLE_TAGS = 5;

export const WIDGET_LIBRARY_VIEWS = {
  LIST: 'list',
  PREVIEW: 'preview',
};

export const WIDGET_PREVIEW_TRAY_GRADIENT = {
  start: '#F6F9FF',
  end: '#FFFFFF',
};

export const ASSIGNEE_TYPES = {
  USER: 'user',
  DEPARTMENT: 'department',
};

export const DASHBOARD_TABS = {
  CREATED: 'created',
  TEMPLATES: 'templates',
};
